import type { ReactElement } from "react";
import { CmtsMasterDataAdminContainer } from "../../core/containers/domain/masterdataRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsMasterDataAdminContainer runtime={props.runtime} />;
}

export default Component;
